// extracted by mini-css-extract-plugin
module.exports = {"loadingLayer":"Chart_loadingLayer__28YbX","spinner":"Chart_spinner__xYbeR"};